import type { PatternRule } from "@soluto-private/soluto-redact-pii";

export const userPatterns: Record<string, Partial<PatternRule> | boolean> = {
    company: {
        pattern: /([A-Z&][\w,]* )+(I[Nn][Cc](orporated)?|C[Oo](rp(oration)?)?|LLP|llc|LLC|plc|gmbh)\.?(\b|$)/,
        flags: "g",
        replaceText: "COMPANY_NAME",
        priority: 1,
    },
    emailAddress: {
        pattern:
            /([a-z0-9_\-.+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|([a-z0-9-]+(\.[a-z0-9-]+)*))([a-z]{2,4}|[0-9]{1,3})(]?)/,
        flags: "gi",
        replaceText: "EMAIL_ADDRESS",
        priority: 1,
    },
    phoneNumber: {
        pattern: /\/(?:\(?\+?(\d{1,3})\)?[-.● ]*)?\(?([0-9]{3})\)?[-.● ]*([0-9]{3,4})[-.● ]*([0-9]{3,4})/,
        flags: "g",
        replaceText: "PHONE_NUMBER",
        priority: 2,
    },
    streetAddress: {
        pattern:
            /(\d+\s*(\w+ ){1,2}(street|st|road|rd|avenue|ave|drive|dr|loop|court|ct|circle|cir|lane|ln|boulevard|blvd|way)\.?\b(\s+(apt|bldg|dept|fl|hngr|lot|pier|rm|ste|slip|trlr|unit|#)\.? *[a-z0-9-]+\b)?)|(P\.? ?O\.? *Box +\d+)/,
        flags: "gi",
        replaceText: "STREET_ADDRESS",
        priority: 1,
    },
    guid: {
        pattern: /([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/,
        flags: "gi",
        replaceText: "UNIQUE_IDENTIFIER",
        priority: 1,
    },
    passportNumber: {
        pattern: /[A-PR-WY][1-9]\d\s?\d{4}[1-9]/,
        flags: "gi",
        replaceText: "PASSPORT_NUMBER",
        priority: 3,
    },
    ipAddress: {
        pattern: /(\d{1,3}(\.\d{1,3}){3}|[0-9A-F]{4}(:[0-9A-F]{4}){5}(::|(:0000)+))/,
        flags: "gi",
        replaceText: "IP_ADDRESS",
        priority: 3,
    },
    creditCard: {
        pattern: /\d{4}[ -]?\d{4}[ -]?\d{4}[ -]?\d{4}|\d{4}[ -]?\d{6}[ -]?\d{4}\d?/,
        flags: "g",
        replaceText: "CREDIT_CARD",
        priority: 4,
    },
    ssn: {
        pattern: /\d{3}[ -.]?\d{2}[ -.]?\d{4}/,
        flags: "g",
        replaceText: "SSN",
        priority: 5,
    },
    zipcode: {
        pattern: /\b\d{5}\b(-\d{4})?\b/,
        flags: "gi",
        replaceText: "ZIP_CODE",
        priority: 6,
    },
    digits: {
        pattern: /(\(?\+?44\)? ?)?(\d(\(?[-.● ]?\d\)?){9,11})/,
        flags: "gi",
        replaceText: "DIGIT_REDACTION",
        priority: 7,
    },
    pinCode: {
        pattern: /\b\d{4}\b/,
        flags: "gi",
        replaceText: "PIN_CODE",
        priority: 8,
    },
};
